import { inject, Injectable } from '@angular/core';
import { jwtDecode } from "jwt-decode";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { AuthToken } from '../models/local/auth-token.model';
import { SelectableLanguages } from '../models/state/profile/profile-state';

@Injectable({
  providedIn: 'root'
})

export class AuthTokenService {

  private readonly oidcSecurityService = inject(OidcSecurityService);

  private token: string;

  constructor() {
  }

  setToken(token: string){
    this.token = token;
  }

  getDecodedToken() {
    try {
      return jwtDecode<AuthToken>(this.token);
    } catch (Error) {
      return null;
    }
  }

  getUserName(): any {
    const decodedToken = this.getDecodedToken();
    return decodedToken?.Firstname + ' ' + decodedToken?.Lastname
  }

  getUserLanguage() : SelectableLanguages | null {
    const decodedToken = this.getDecodedToken();    
    return decodedToken ? decodedToken.Language as SelectableLanguages : null;
  }

  getUserEmail(): string | null {
    const decodedToken = this.getDecodedToken();
    return decodedToken ? decodedToken.email : null;
  }

  getUserScope(): string | null {
    const decodedToken = this.getDecodedToken();
    return decodedToken ? decodedToken.scope : null;
  }
}
